module.exports = __webpack_public_path__ + "img/banner1_m.c12cc219.png";